/**
 * Klucze React Query modulu kontraktow.
 *
 * DLACZEGO OSOBNY PLIK: klucz listy jest uzywany w szesciu widokach, a repo
 * wymaga, zeby klucz wspoldzielony miedzy plikami byl eksportowana fabryka
 * (konwencja `*_QUERY_KEY`).
 *
 * DLACZEGO SEGMENT "list": React Query hashuje klucz przez JSON.stringify,
 * wiec `undefined` w tablicy staje sie `null`. Plaskie
 * `["contracts", selectedTenantId]` (lista, tenantId = null dla zwyklego
 * konta) kolidowalo z `["contracts", id]` formularza na /kontrakty/nowy
 * (id = undefined) — formularz czytal z cache TABLICE kontraktow i brał ja
 * za wczytywany kontrakt. Ten sam plaski ksztalt lapal tez kolizje
 * tenant_id = contract_id. Segment rozroznia zasoby raz na zawsze.
 *
 * Prefiks `contracts` zostaje na pierwszej pozycji, zeby zbiorcze
 * `invalidateQueries({ queryKey: ["contracts"] })` po zapisie kontraktu
 * nadal lapalo liste.
 */

/** Lista kontraktow widoczna w danej organizacji. */
export const contractsListQueryKey = (tenantId: number | null) =>
	["contracts", "list", tenantId] as const;

/**
 * Klucz formularza w trybie tworzenia. Wlasna, jawna wartosc zamiast
 * `["contracts", undefined]` — zapytanie i tak jest wylaczone, ale klucz nie
 * moze wskazywac na cudzy wpis cache.
 */
export const NEW_CONTRACT_QUERY_KEY = ["contracts", "nowy"] as const;
